if (!customElements.get('slideshow-slider')) {
  class SlideshowSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.options = {
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        slidesPerView: 1,
        loop: true,
      };
      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('slideshow-slider', SlideshowSlider);
}
